export default "__VITE_ASSET__EvOkQiVM__"